module.exports = __webpack_public_path__ + "img/图1.26fc3c6e.png";